// import * as Utils from "../utils/utils";
import PlayerPaths from "../constants/paths/playerPaths";

export function setCompletionState(tree, listIndex, sectionIndex) {
	// loop through item siblings and mark parent (section) completion status
	let section = tree.get(PlayerPaths.ACTIVITY_SECTION(listIndex, sectionIndex));
	tree.set(PlayerPaths.ACTIVITY_SECTION_PROPERTY(listIndex, sectionIndex, "completionState"), setSectionCompletionState(tree, section));

	// loop through section siblings and mark parent (list) completion status
	let list = tree.get(PlayerPaths.ACTIVITY_LIST(listIndex));
	tree.set(PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "completionState"), setListCompletionState(tree, list));

	// loop through list siblings and mark parent (activity) completion status
	tree.set(PlayerPaths.ACTIVITY_PROPERTY("completionState"), setActivityCompletionState(tree));
}

// Can potentially reuse this function for lists and activity as well
function setSectionCompletionState(tree, section) {
	let items = section.children;
	let checkedCount = 0;
	let ignoreCompletionCount = 0;
	for (let i = 0, len = items.length; i < len; i++) {
		// if ((items[i].hasOwnProperty("ignoreCompletion") && items[i].ignoreCompletion) || !Utils.isVisible(items[i])) {
		if ((items[i].hasOwnProperty("ignoreCompletion") && items[i].ignoreCompletion)) {
			ignoreCompletionCount++;
		} else {
			if (items[i].checked) {
				checkedCount++;
			}
		}
	}

	if (checkedCount === 0) {
		return "n";
	} else if (checkedCount < (items.length - ignoreCompletionCount)) {
		return "i";
	} else {
		return "c";
	}
}

// Can reuse this function for Activity as well
function setListCompletionState(tree, list) {
	let sections = list.children;
	let notStartedCount = 0;
	let completeCount = 0;
	let ignoreCompletionCount = 0;
	for (let i = 0, len = sections.length; i < len; i++) {
		// if ((sections[i].hasOwnProperty("ignoreCompletion") && sections[i].ignoreCompletion) || !Utils.isVisible(sections[i])) {
		if ((sections[i].hasOwnProperty("ignoreCompletion") && sections[i].ignoreCompletion)) {
			ignoreCompletionCount++;
		} else {
			if (sections[i].completionState === "c") {
				completeCount++;
			} else if (sections[i].completionState === "n") {
				notStartedCount++;
			}
		}
	}

	if (completeCount === (sections.length - ignoreCompletionCount)) {
		return "c";
	} else if (notStartedCount === (sections.length - ignoreCompletionCount)) {
		return "n";
	} else {
		return "i";
	}
}

function setActivityCompletionState(tree) {
	let activity = tree.get(PlayerPaths.ACTIVITY);

	let lists = activity.children;
	let notStartedCount = 0;
	let completeCount = 0;
	let ignoreCompletionCount = 0;
	let allIgnored = false;
	for (let i = 0, len = lists.length; i < len; i++) {
		// if ((lists[i].hasOwnProperty("ignoreCompletion") && lists[i].ignoreCompletion) || !Utils.isVisible(lists[i])) {
		if ((lists[i].hasOwnProperty("ignoreCompletion") && lists[i].ignoreCompletion)) {
			ignoreCompletionCount++;
		} else {
			if (lists[i].completionState === "c") {
				completeCount++;
			} else if (lists[i].completionState === "n") {
				notStartedCount++;
			}
		}
	}

	if (ignoreCompletionCount === lists.length) {
		allIgnored = true;
	}

	if (completeCount === (lists.length - ignoreCompletionCount)) {
		if (activity.completionState !== "c") {
			if (!allIgnored) {
				//Alert.alert(tree.get(["content"]).alerts.congrats, tree.get(["content"]).alerts.congratsMessage);
			}
		}
		return "c";
	} else if (notStartedCount === (lists.length - ignoreCompletionCount)) {
		return "n";
	} else {
		return "i";
	}
}
